// #region Dependencias
import styled from 'styled-components'
// #endregion

// #region Estilos
const StyledSvg = styled.svg`
  height: ${({ size }) => (size === 'small' ? '20px' : size === 'large' ? '50px' : '30px')};
  width: ${({ size }) => (size === 'small' ? '20px' : size === 'large' ? '50px' : '30px')};
  transition: filter 0.15s;

  ${(props) =>
    !props.disabled &&
    props.hover &&
    `
    &:hover {
      cursor: pointer;
      filter: brightness(0.75);
    }`}

  ${({ disabled }) =>
    disabled &&
    `
    filter: opacity(0.25);
    `}
`
// #endregion

/**
 * Componente que renderiza un icono SVG.
 * @class
 * @example
 * <Icon>
 *  <path ... />
 * </Icon>
 *
 * @param {Object} props - Propiedades del componente.
 * @param {boolean} props.disabled - Valor que indica si el ícono está desactivado.
 * @param {boolean} props.hover - Valor que indica si el ícono tiene animación al hacer hover.
 * @param {string} props.size - Tamaño del ícono.
 * @param {string} props.title - Título del ícono.
 * @param {React.ReactNode} props.children - Contenido que será renderizado dentro del componente.
 */
const Icon = ({ title, children, ...props }) => {
  return (
    <StyledSvg {...props}>
      {children} {title && <title>{title}</title>}
    </StyledSvg>
  )
}

export default Icon
